"use client";

import dynamic from "next/dynamic";

const ErrorDisplay = dynamic(
  () => import("@directv-digital/dds.ui.error-display"),
  { ssr: false }
);

export default function WncMainCanvasErrorDisplay({ error }: { error: Error }) {
  return <ErrorDisplay component="WncMainCanvas" error={error} />;
}
